import Tr from "translations/Translations";

const formatBoolean = (val) => {
    if (val === null || val === undefined) {
        return null;
    }
    return !val ? Tr("no") : Tr("yes");
}

export default formatBoolean;